import { BRAND } from "@/config/links";

/**
 * Left info/progress rail for the intro + question screens — shared
 * by every diagnostic (EP Communication Diagnostic, Presentation
 * Readiness Check). Adapts the reference screenshots' sidebar
 * morphology (eyebrow, giant step counter, progress indicator,
 * blurb, bottom tagline) to the site's own palette. A slim progress
 * bar replaces the reference's per-question dots once past ~10
 * steps, where individual dots would turn to visual noise — same
 * underlying "progress" material, just the already-existing bar
 * treatment instead of inventing dots that don't scale to higher
 * question counts.
 */
export const LeftRail = ({ eyebrow, stepIndex, stepTotal, blurb }) => {
  const pct = stepTotal ? Math.round((stepIndex / stepTotal) * 100) : 0;
  return (
    <aside
      className="lg:w-[340px] shrink-0 bg-paper-deep border-b lg:border-b-0 lg:border-r border-ink/10 px-6 md:px-10 py-10 lg:py-16 flex flex-col"
      data-testid="diagnostic-left-rail"
    >
      <p className="font-body text-xs uppercase tracking-[0.24em] text-terracotta mb-6">{eyebrow}</p>
      <p className="font-serif text-5xl md:text-6xl text-charcoal leading-none mb-5" data-testid="diagnostic-left-rail-counter">
        {String(stepIndex).padStart(2, "0")}
        <span className="text-ink-soft/50 text-2xl md:text-3xl">/{String(stepTotal).padStart(2, "0")}</span>
      </p>
      <div className="h-1.5 rounded-full bg-ink/10 overflow-hidden mb-8">
        <div className="h-full rounded-full bg-terracotta transition-all duration-300" style={{ width: `${pct}%` }} />
      </div>
      <p className="font-body text-sm text-ink-soft leading-relaxed">{blurb}</p>
      <p className="hidden lg:block mt-auto pt-16 font-hand text-xl text-ink-soft/70">{BRAND.tagline}</p>
    </aside>
  );
};

export default LeftRail;
